<template>
    <div class="page-restore-confirm">
        <div class="block-title">
            {{ firstSet ? 'Установление пароля' : 'Восстановление пароля' }}
            <Loader v-show="pending" class="loader" />
        </div>

        <div v-if="message" class="notification error">
            <IconError class="icon" />
            <div class="text error" v-html="message" />
        </div>

        <div class="form-field">
            <div class="title">Новый пароль</div>
            <div class="value">
                <password v-model="v.password.$model"
                          :a-class="{ error: v.password.$error }"
                          data-test-id="input-password"
                          placeholder="Введите новый пароль" />
                <TooltipOld :opened="!!passwordError" bind-to="[data-test-id=input-password]"
                         class="error" trigger-on="focus">{{ passwordError }}
                </TooltipOld>
                <TooltipOld :opened="!passwordError && !safetyHard" bind-to="[data-test-id=input-password]"
                         class="inform password" trigger-on="focus">
                    <SafetyPassword :password="password" />
                </TooltipOld>
            </div>
        </div>

        <div class="form-field">
            <div class="title">Новый пароль (еще раз)</div>
            <div class="value">
                <password v-model="v.password2.$model"
                          :a-class="{ error: v.password2.$error }"
                          data-test-id="input-password2"
                          placeholder="Введите новый пароль повторно" />
                <TooltipOld :opened="!!passwordConfirmError" bind-to="[data-test-id=input-password2]"
                         class="error" trigger-on="focus">{{ passwordConfirmError }}
                </TooltipOld>
            </div>
        </div>

        <div class="form-field form-action">
            <div class="value">
                <button :disabled="v.$invalid || pending"
                        class="primary fullwidth action"
                        data-test-id="input-confirm"
                        @click="confirm">Сохранить и войти
                </button>
            </div>
        </div>

        <div v-show="!firstSet" class="form-field">
            <div class="value">
                <router-link class="accent" to="/user/login">Перейти к входу</router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { updateSession } from '@/common/session.js';
import { entropy } from '@/common/validators.js';
import IconError from '@/pages/user/icons/error.svg?component';
import { restoreConfirm } from '@/restapi/user/user.js';
import { useVuelidate } from '@vuelidate/core';
import { minLength, required, sameAs } from '@vuelidate/validators';
import SafetyPwdMixin from '@/common/comp/safety_password/safety.pwd.mixin.js';
import SafetyPassword from '@/common/comp/safety_password/SafetyPassword.vue';

export default {
    mixins: [ SafetyPwdMixin ],
    components: {
        IconError,
        SafetyPassword,
    },
    setup() {
        return {
            v: useVuelidate(),
        };
    },
    data() {
        return {
            tokenId: '',
            firstSet: !!this.$route.query?.firstSet,
            password: '',
            password2: '',
            message: '',

            pending: false,
        };
    },
    computed: {
        passwordError() {
            if (!this.v.password.$dirty)
                return null;

            if (this.v.password.required.$invalid)
                return 'Не указан пароль';

            return null;
        },
        passwordConfirmError() {
            if (!this.v.password2.$dirty)
                return null;

            if (this.v.password2.required.$invalid)
                return 'Подтвердите пароль';

            if (this.v.password2.sameAs.$invalid)
                return 'Пароли не совпадают';

            return null;
        },
    },
    validations() {
        return {
            tokenId: { required },
            password: {
                required,
                minLength: minLength(8),
                entropy: entropy(24),
            },
            password2: {
                required,
                sameAs: sameAs(this.password),
            },
        };
    },
    methods: {
        async checkCode() {
            this.tokenId = this.$route.query?.id;

            if (!this.tokenId) {
                this.message = 'Не передан код подтверждения';

            }

        },
        async confirm() {
            this.v.$touch();

            if (this.v.$invalid)
                return;

            this.pending = true;

            try {
                const user = await restoreConfirm({
                    tokenId: this.tokenId,
                    password: this.password,
                });

                updateSession(user);
                this.$router.push('/');

            } catch (e) {
                this.message = e.message;
            } finally {
                this.pending = false;
            }
        },
    },
    created() {
        this.checkCode();
    },
};
</script>

<style lang="scss" scoped>
@import '../../../common/comp/safety_password/safety.pwd';

.page-restore-confirm {
}
</style>
